import { render, staticRenderFns } from "./tab-pane.vue?vue&type=template&id=9145a070&"
import script from "./tab-pane.vue?vue&type=script&lang=js&"
export * from "./tab-pane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/builds/MWmsPKDH/0/framework/qmai-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9145a070')) {
      api.createRecord('9145a070', component.options)
    } else {
      api.reload('9145a070', component.options)
    }
    module.hot.accept("./tab-pane.vue?vue&type=template&id=9145a070&", function () {
      api.rerender('9145a070', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/tabs/src/tab-pane.vue"
export default component.exports